/**
 * Sprint T-18 · Notification Studio · Analytics · Errors table + Latency table.
 *
 * Two small tables side-by-side. Each has a title, up to N rows, and a "sin datos"
 * empty state.
 */
import React from "react";

export function ErrorsTable({ data, title, loading, testid }) {
  const items = data?.items || [];
  return (
    <div
      className="rounded border border-[var(--ag-border)] bg-[var(--ag-panel)] p-3"
      data-testid={testid}
    >
      <div className="mb-2 flex items-center justify-between">
        <div className="text-[10px] uppercase tracking-widest text-[var(--ag-text-dim)]">
          {title}
        </div>
        <div className="text-[10px] text-[var(--ag-text-dim)]">
          Top {data?.top_n ?? 5}
        </div>
      </div>
      {loading && !data ? (
        <div className="text-xs text-[var(--ag-text-dim)]">cargando…</div>
      ) : items.length === 0 ? (
        <div
          className="rounded border border-dashed border-[var(--ag-border)] p-3 text-center text-[10px] text-[var(--ag-text-dim)]"
          data-testid={`${testid}-empty`}
        >
          Sin errores en el rango.
        </div>
      ) : (
        <table className="w-full text-[11px]">
          <thead className="text-[9px] uppercase tracking-widest text-[var(--ag-text-dim)]">
            <tr>
              <th className="py-1 text-left">{data?.group_by || "key"}</th>
              <th className="py-1 text-right">count</th>
            </tr>
          </thead>
          <tbody>
            {items.map((it) => (
              <tr
                key={it.key}
                className="border-t border-[var(--ag-border)]/50"
                data-testid={`${testid}-row-${(it.key || "").slice(0, 40)}`}
              >
                <td className="py-1 font-mono text-xs text-[var(--ag-text)]">
                  {it.key}
                </td>
                <td className="py-1 text-right font-mono text-xs text-rose-300">
                  {it.count}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}

export function LatencyTable({ data, loading }) {
  const channels = data?.channels || [];
  return (
    <div
      className="rounded border border-[var(--ag-border)] bg-[var(--ag-panel)] p-3"
      data-testid="studio-analytics-latency-table"
    >
      <div className="mb-2 text-[10px] uppercase tracking-widest text-[var(--ag-text-dim)]">
        Latency by channel (ms)
      </div>
      {loading && !data ? (
        <div className="text-xs text-[var(--ag-text-dim)]">cargando…</div>
      ) : channels.length === 0 ? (
        <div className="rounded border border-dashed border-[var(--ag-border)] p-3 text-center text-[10px] text-[var(--ag-text-dim)]">
          Sin data en el rango.
        </div>
      ) : (
        <table className="w-full text-[11px]">
          <thead className="text-[9px] uppercase tracking-widest text-[var(--ag-text-dim)]">
            <tr>
              <th className="py-1 text-left">channel</th>
              <th className="py-1 text-right">count</th>
              <th className="py-1 text-right">p50</th>
              <th className="py-1 text-right">p95</th>
              <th className="py-1 text-right">p99</th>
            </tr>
          </thead>
          <tbody>
            {channels.map((c) => (
              <tr
                key={c.channel}
                className="border-t border-[var(--ag-border)]/50"
                data-testid={`studio-analytics-latency-row-${c.channel}`}
              >
                <td className="py-1 font-mono text-xs">{c.channel}</td>
                <td className="py-1 text-right font-mono text-[var(--ag-text-dim)]">
                  {c.count}
                </td>
                <td className="py-1 text-right font-mono text-xs">{c.p50}</td>
                <td className="py-1 text-right font-mono text-xs text-amber-300">
                  {c.p95}
                </td>
                <td className="py-1 text-right font-mono text-xs text-rose-300">
                  {c.p99}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
